import * as Sentry from "@sentry/react";

import { isLocalhost } from "helpers/commonHelpers";
import packageJson from "../package.json";

const { version } = packageJson;

Sentry.init({
  dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  integrations: [],
  // Set tracesSampleRate to 0 since we're only tracking errors
  tracesSampleRate: 0,
  release: `cargobase-react@${version}`,
  environment: import.meta.env.REACT_APP_ENVIRONMENT_NAME,
  enabled: !isLocalhost,
});
